import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { userBalancesBackend } from './user-balances.backend';
import { userBalancesReducer } from './user-balances.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userBalances', userBalancesReducer),
    BackendModule.forFeature('userBalances', userBalancesBackend),
  ],
})
export class DatastoreUserBalancesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-balances/user-balances.module.ts